import { StreamingPriceActions } from 'state/quotes/streaming/streaming.actions';

import type { DashboardAction } from './dashboard/dashboard.actions';
import type { PendingQuoteDetailsActions } from './pendingDetails/pendingDetails.action';
import type { RegulationActions } from './regulations/regulation.actions';
export type QuotesAction =
  | QuotesRemoved
  | DashboardAction
  | PendingQuoteDetailsActions
  | RegulationActions
  | StreamingPriceActions;

export function quotesRemoved(tabId?: string, ...quoteIds: string[]) {
  return {
    type: 'QUOTES_REMOVED' as const,
    tabId,
    quoteIds,
  };
}
export type QuotesRemoved = ReturnType<typeof quotesRemoved>;
